import { Component } from '@angular/core';

import { State, StateService } from '@res/ngg-core';
import { LayoutDirectionSwitcherComponent } from '../layout-direction-switcher/layout-direction-switcher.component';
import { NbButtonModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [LayoutDirectionSwitcherComponent, NbButtonModule, CommonModule],
  selector: 'nggt-theme-settings',
  styleUrls: ['./theme-settings.component.scss'],
  template: `
    <span class="subheader">Layouts</span>
    <div class="settings-row">
      <button
        *ngFor="let layout of layouts"
        nbButton
        [appearance]="layout.selected ? 'outline' : 'ghost'"
        [attr.aria-label]="layout.name"
        (click)="layoutSelect(layout)"
        class="select-button"
      >
        <i [attr.class]="layout.icon + ' setting-icon'"></i>
      </button>
    </div>

    <span class="subheader">Sidebar</span>
    <div class="settings-row">
      <button
        *ngFor="let sidebar of sidebars"
        nbButton
        [appearance]="sidebar.selected ? 'outline' : 'ghost'"
        [attr.aria-label]="sidebar.name"
        (click)="sidebarSelect(sidebar)"
        class="select-button"
      >
        <i [attr.class]="sidebar.icon + ' setting-icon'"></i>
      </button>
    </div>

    <span class="subheader layout-setting-heading">Layout direction</span>
    <div class="settings-row">
      <div class="switcher">
        <nggt-layout-direction-switcher></nggt-layout-direction-switcher>
      </div>
    </div>
  `,
})
export class ThemeSettingsComponent {
  layouts: State[] = [];
  sidebars: State[] = [];

  constructor(protected stateService: StateService) {
    this.stateService.getLayoutStates().subscribe((layouts: State[]) => (this.layouts = layouts));

    this.stateService.getSidebarStates().subscribe((sidebars: State[]) => (this.sidebars = sidebars));
  }

  layoutSelect(layout: State): boolean {
    this.layouts = this.layouts.map((l) => {
      l.selected = false;
      return l;
    });

    layout.selected = true;
    this.stateService.setLayoutState(layout);
    return false;
  }

  sidebarSelect(sidebar: State): boolean {
    this.sidebars = this.sidebars.map((s) => {
      s.selected = false;
      return s;
    });

    sidebar.selected = true;
    this.stateService.setSidebarState(sidebar);
    return false;
  }
}
